import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.043 11.895c0 .765.674 1.36 1.541 1.36h11.367v3.994c0 1.02 1.54 1.955 2.6.935l5.973-5.27c.578-.51.578-1.36 0-1.87L16.55 5.776c-.963-.85-2.6-.255-2.6.935v3.995s-7.321-.085-11.463 0c-.77-.17-1.445.425-1.445 1.19Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }